import { Grid, Group, Page } from "@/comn/components";
import { useFetch, useGrid, usePage, useToast } from "@/comn/hooks";
import { useEffect } from "react";
import { APIS, PGEUIDS, SG_MENU_LIST } from "@/tz/go/egaz/osci/ptl/ptl/auth/services/OsciRoleAuthService";

/*
 *  Menu List Popup
 * !== 메뉴 목록 팝업 ==!
 */
export const OSCI0104019Q = (props: any) => {
    const { pgeUid } = usePage({ pgeUid: PGEUIDS.osci0104019q });
    const toast = useToast();

    const grid = { menuList: useGrid({ defaultSchema: SG_MENU_LIST }) };

    const fetch = {
        getMenuList: useFetch({
            api: (data: any) => APIS.getMenuList(data),
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    useEffect(() => {
        grid.menuList.setOption("height", 200);
        fetch.getMenuList.fetch(props);
    }, []);

    return (
        <Page pgeUid={pgeUid} info={true}>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.menuList.grid} data={fetch.getMenuList.data?.menuList} />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
